import * as z from "zod/v4";

export const enableDisputes = {
  name: "enableDisputes" as const,
  input: z.object({}),
  output: z.object({ success: z.boolean() }),
};
